/*!

=========================================================
* Now UI Dashboard React - v1.5.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useState } from "react";
// react plugin used to create charts
// import { Line, Bar } from "react-chartjs-2";
import Swal from "sweetalert2";
import axios from "axios";
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Row,
    Col
} from "reactstrap";

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import { BASE_URL } from "utils/constants";
import Line from "../components/Chart/Line";

// const eagleCardBackground = process.env.PUBLIC_URL + '/assets/images/-3.png';
const eagleCardWidth = 200;
const eagleCardHeight = 300;
const eagleCardStep = 10;
// const calculate_eagleCardCount_from_Reinforcements = (Reinforcements) => {
//     let total = 0;
//     for (let index = 0; index < (Reinforcements?.length ?? 0); index++) {

//         total += +(Reinforcements[index]?.points ?? 0);
//     }
//     return Math.floor(total / 10);
// }


function Dashboard() {
    const [services, setServices] = useState([]);
    // const [Reinforcements, setReinforcements] = useState([]);
    //   const [first, setfirst] = useState(second)
    const [eagleCardCount, setEagleCardCount] = useState(0);
    const [RP, setRP] = useState(0);
    const [consumed, setConsumed] = useState(0);
    const [totalEagles, setTotalEagles] = useState(0);



    useEffect(async () => {
        try {
            const res = await axios.get(`${BASE_URL}/services/getservices.php`);
            setServices(res.data.data);
        } catch {
            Swal.fire('Failed to get services!', '', 'error');
        }
    }, [])
    // useEffect(async () => {
    //     try {
    //         const res = await axios.get(`${BASE_URL}/reinforcements/getreinforcements.php`);
    //         setReinforcements(res.data.data);
    //         const tmp_Reinforcements = res?.data?.data ?? [];
    //         if (tmp_Reinforcements && (tmp_Reinforcements?.length ?? false)) {
    //             setEagleCardCount(calculate_eagleCardCount_from_Reinforcements(tmp_Reinforcements));
    //         }
    //     } catch {
    //         Swal.fire('Failed to get reinforcements!', '', 'error');
    //     }
    // }, [])
    useEffect(async () => {
        try {
            const res = await axios.get(`${BASE_URL}/eagle_card/get_eagle_cards.php`);
            
            setEagleCardCount(res?.data?.data?.remaining ?? 0);
            setRP(res?.data?.data?.RP ?? 0)
            setConsumed(res?.data?.data?.consumed ?? 0)
            setTotalEagles(res?.data?.data?.total_eagle_cards ?? 0 )
        } catch {
            Swal.fire('Failed to get Eagle Cards!', '', 'error');
        }
    }, [])
    return (
        <>
            <PanelHeader size="sm" />

            <div className="content">
                <Row>
                    <Col md={12}>
                        <Card>
                            <CardHeader>
                                <h4 className="title">Services</h4>
                                <hr />
                            </CardHeader>
                            {/* <CardBody>
                                <h5> eagleCardCount : </h5>
                                <h5> {eagleCardCount}</h5>
                            </CardBody> */}
                            <CardBody>
                                <h5>
                                    RP :{" "}
                                    <span
                                        style={{
                                            color: Number(RP) > 0 ? "#28a745" : Number(RP) < 0 ? "#dc3545" : "inherit",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        {Number(RP) > 0 ? `+${RP}` : RP}
                                    </span>
                                </h5>
                                <h5>Used Eagle cards : {consumed}</h5>
                                <h5>Available Eagle Cards : {eagleCardCount > 0 ? eagleCardCount : 0}</h5>
                                {
                                    (() => {
                                        if (0 >= eagleCardCount) {
                                            return null;
                                        }
                                        const eagleCardArr = Array.from({ length: eagleCardCount }, (_, index) => index);


                                        const eagleCardCount_X_eagleCardStep = eagleCardCount * eagleCardStep;
                                        const countTop = (eagleCardCount_X_eagleCardStep) - 5;
                                        const countLeft = (eagleCardCount_X_eagleCardStep) + eagleCardWidth - 15;
                                        const allHieght = (eagleCardCount_X_eagleCardStep) + eagleCardHeight - 15;

                                        return (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    justifyContent: "center",
                                                    position: "relative",
                                                    marginTop: `${countTop + 10}px`,
                                                    height: `${allHieght}px`,
                                                }}>
                                                {
                                                    eagleCardArr?.map((count) => (
                                                        <img
                                                            src="assets/images/eagle_card_background.jpg"
                                                            key={count}
                                                            style={{
                                                                // backgroundImage: `url(${eagleCardBackground})`,
                                                                // backgroundRepeat: 'no-repeat',
                                                                // backgroundSize: 'cover',
                                                                // backgroundPosition: 'center',
                                                                position: "absolute",
                                                                left: `${count * eagleCardStep}px`,
                                                                top: `-${count * eagleCardStep}px`,
                                                                width: `${eagleCardWidth}px`,
                                                                height: `${eagleCardHeight}px`,
                                                                backgroundColor: "white",
                                                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                                                margin: "10px",
                                                                borderRadius: "10px",
                                                                overflow: "hidden",
                                                                // backgroundImage: "assets/images/-3.png",
                                                            }}
                                                            alt=""
                                                        />
                                                    ))
                                                }
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        top: `-${countTop}px`,
                                                        left: `${countLeft}px`,
                                                        backgroundColor: "red",
                                                        color: "white",
                                                        borderRadius: "50%",
                                                        width: "30px",
                                                        height: "30px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    {eagleCardCount}
                                                </div>
                                            </div>
                                        );
                                    })()
                                }

                            </CardBody>
                            {/* <CardBody>
                                <h5> Reinforcement points : </h5>
                                <Line color="blue" Reinforcements={Reinforcements} />
                            </CardBody> */}
                            <CardBody className="all-icons">
                                <Row>
                                    {services.map((s, key) => {
                                        return (
                                            <Col
                                                xl={3}
                                                lg={4}
                                                md={4}
                                                sm={6}
                                                xs={12}
                                                className="font-icon-list"
                                                key={key}
                                            >
                                                <a href={s.link} target="_blank">
                                                    {s.type == 'edu' && <div className="row font-icon-detail align-items-even justify-content-center service" style={{ height: '250px', boxShadow: '5px 10px #FFA400' }}>
                                                        <img className="col-12" src={s.image} alt='service image' style={{ maxWidth: '60%', height: '90px' }} />
                                                        <p className="col-12 text-center fw-bolder" style={{ fontSize: "14pt", color: "#0A1931", fontWeight: 'bold' }} >{s.name}</p>
                                                    </div>}
                                                    {s.type == 'microsoft' && <div className="row font-icon-detail align-items-even justify-content-center service" style={{ height: '250px', boxShadow: '5px 10px #39A2DB' }}>
                                                        <img className="col-12" src={s.image} alt='service image' style={{ maxWidth: '35%', height: '70px' }} />
                                                        <p className="col-12 text-center fw-bolder" style={{ fontSize: "14pt", color: "#0A1931", fontWeight: 'bold' }} >{s.name}</p>
                                                    </div>}
                                                    {s.type == 'google' && <div className="row font-icon-detail align-items-even justify-content-center service" style={{ height: '250px', boxShadow: '5px 10px #81B214' }}>
                                                        <img className="col-12" src={s.image} alt='service image' style={{ maxWidth: '35%', height: '70px' }} />
                                                        <p className="col-12 text-center fw-bolder" style={{ fontSize: "14pt", color: "#0A1931", fontWeight: 'bold' }} >{s.name}</p>
                                                    </div>}
                                                </a>
                                            </Col>
                                        );
                                    })}
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
}

export default Dashboard;
